import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.23, 1, 0.32, 1];
const VIEWPORT = { once: true, margin: "0px 0px -15% 0px" };

/** Fade + short rise as the element scrolls into view (once). */
export const Reveal = ({
  as = "div",
  children,
  className,
  delay = 0,
  y = 16,
  ...rest
}) => {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.div;

  return (
    <Tag
      className={className}
      initial={
        reduce
          ? { opacity: 0 }
          : { opacity: 0, transform: `translateY(${y}px)` }
      }
      whileInView={
        reduce ? { opacity: 1 } : { opacity: 1, transform: "translateY(0px)" }
      }
      viewport={VIEWPORT}
      transition={{ duration: 0.6, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

/** Clip-path wipe from the top — for imagery. */
export const RevealMedia = ({ children, className, ...rest }) => {
  const reduce = useReducedMotion();

  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { clipPath: "inset(0 0 100% 0)" }}
      whileInView={reduce ? { opacity: 1 } : { clipPath: "inset(0 0 0% 0)" }}
      viewport={{ once: true, margin: "0px 0px -12% 0px" }}
      transition={{ duration: 0.75, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
